// Author Sort Functionality for Shopify Dawn Theme
// This script handles custom sorting by author metafield

class AuthorSort {
  constructor() {
    this.isAuthorSort = false;
    this.init();
  }

  init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    // Check URL for author sort parameter on page load
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    
    if (sortBy === 'author-az' || sortBy === 'author-za') {
      this.isAuthorSort = true;
      // Use setTimeout to ensure products are loaded
      setTimeout(() => this.sortProductsByAuthor(sortBy), 100);
    }

    // Intercept all sort dropdown changes
    this.interceptSortChanges();
    
    // Prevent facets form submission for author sorts
    this.interceptFacetForms();
  }

  interceptSortChanges() {
    // Use event delegation on document to catch all sort dropdowns
    document.addEventListener('change', (e) => {
      if (e.target.matches('select[name="sort_by"]')) {
        const sortValue = e.target.value;
        
        if (sortValue === 'author-az' || sortValue === 'author-za') {
          // Prevent any default behavior
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          this.isAuthorSort = true;
          this.sortProductsByAuthor(sortValue);
          
          // Update URL without page reload
          const url = new URL(window.location);
          url.searchParams.set('sort_by', sortValue);
          window.history.pushState({}, '', url);
          
          // Update all other sort dropdowns to match
          document.querySelectorAll('select[name="sort_by"]').forEach(select => {
            if (select !== e.target) {
              select.value = sortValue;
            }
          });
        } else {
          this.isAuthorSort = false;
        }
      }
    }, true); // Use capture phase
  }

  interceptFacetForms() {
    // Prevent form submissions when author sort is active
    document.addEventListener('submit', (e) => {
      if (this.isAuthorSort && e.target.matches('form[id*="Facet"]')) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    }, true);

    // Intercept facet filter form changes
    const facetForms = document.querySelectorAll('facet-filters-form, form.facets-vertical-form');
    facetForms.forEach(form => {
      const originalSubmit = form.submit;
      form.submit = () => {
        if (!this.isAuthorSort) {
          originalSubmit.call(form);
        }
      };
    });

    // Watch for AJAX requests and re-sort if needed
    this.observeProductGrid();
  }

  observeProductGrid() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!productGridContainer) return;

    let sortTimeout;
    const observer = new MutationObserver((mutations) => {
      if (this.isAuthorSort) {
        const urlParams = new URLSearchParams(window.location.search);
        const sortBy = urlParams.get('sort_by');
        if (sortBy === 'author-az' || sortBy === 'author-za') {
          // Clear any pending sort operations
          clearTimeout(sortTimeout);
          
          // Debounce the re-sort to prevent multiple rapid sorts
          sortTimeout = setTimeout(() => {
            this.sortProductsByAuthor(sortBy);
          }, 150);
        }
      }
    });

    observer.observe(productGridContainer, {
      childList: true,
      subtree: true
    });
  }

  sortProductsByAuthor(direction) {
    const productGrid = document.getElementById('product-grid');
    
    if (!productGrid) {
      console.warn('Product grid not found');
      return;
    }

    // Get all product items
    const productItems = Array.from(productGrid.querySelectorAll('.grid__item'));
    
    if (productItems.length === 0) {
      console.warn('No products found to sort');
      return;
    }

    console.log(`Sorting ${productItems.length} products by author (${direction})`);

    // Disable animations temporarily to prevent flickering
    productGrid.style.transition = 'none';
    productItems.forEach(item => {
      item.style.transition = 'none';
      // Temporarily disable scroll animations
      if (item.classList.contains('scroll-trigger')) {
        item.classList.add('scroll-trigger-disabled');
        item.classList.remove('scroll-trigger');
      }
    });

    // Sort the items
    productItems.sort((a, b) => {
      const authorA = (a.getAttribute('data-author') || '').toLowerCase().trim();
      const authorB = (b.getAttribute('data-author') || '').toLowerCase().trim();
      
      // Handle empty authors (push to end)
      if (!authorA && !authorB) return 0;
      if (!authorA) return 1;
      if (!authorB) return -1;
      
      // Sort alphabetically
      if (direction === 'author-az') {
        return authorA.localeCompare(authorB);
      } else {
        return authorB.localeCompare(authorA);
      }
    });

    // Use a document fragment for better performance
    const fragment = document.createDocumentFragment();
    
    // Reappend sorted items to fragment
    productItems.forEach((item, index) => {
      // Update animation order for scroll animations
      item.style.setProperty('--animation-order', index + 1);
      
      // Remove any transform or animation styles
      item.style.transform = 'none';
      item.style.opacity = '1';
      
      fragment.appendChild(item);
    });

    // Clear and update grid in one operation
    productGrid.innerHTML = '';
    productGrid.appendChild(fragment);

    // Re-enable animations after a brief delay
    requestAnimationFrame(() => {
      productGrid.style.transition = '';
      productItems.forEach(item => {
        item.style.transition = '';
        // Re-enable scroll animations
        if (item.classList.contains('scroll-trigger-disabled')) {
          item.classList.remove('scroll-trigger-disabled');
          item.classList.add('scroll-trigger');
          // Mark as animated so they don't animate in
          item.classList.add('animate--slide-in');
        }
      });
    });

    // Mark that we've done author sorting
    productGrid.setAttribute('data-author-sort', 'true');
    console.log('Products sorted successfully');
  }
}

// Initialize the author sort functionality
new AuthorSort();